import React, { useEffect, useState } from "react";
import { API } from "../utils/Apis";
import { showToast } from "../utils/helpers";
import { Accordion, Button } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPlus,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import ContentItemForm from "./Modals/ContentItemForm";

interface AccordianDataContentType {
  type: "about" | "health_and_safety" | "policy";
  spaceId: string;
}

interface ContentItemType {
  id: string;
  heading: string;
  content: string;
}

// Brief context shown under each tab's heading so hosts know what to add
const SECTION_DESCRIPTIONS: Record<
  AccordianDataContentType["type"],
  string
> = {
  about:
    "Add information about your space's story, history, or unique features.",
  health_and_safety: "Add your health and safety guidelines for guests.",
  policy: "Add your booking, cancellation, and house rules.",
};

const AccordianDataContent: React.FC<AccordianDataContentType> = ({
  type = "about",
  spaceId,
}) => {
  const [fetching, setFetching] = useState(true);

  const [deleting, setDeleting] = useState({});

  const [items, setItems] = useState<Array<ContentItemType>>([]);

  const [addEditForm, setAddEditForm] = useState({ show: false, item: {} });

  const updateItem = (newItem: object) => {
    console.log("New Item :", newItem);

    const tempItems = [...items];
    const index = items.findIndex((item) => item.id === newItem.id);

    if (index !== -1) {
      tempItems[index] = { ...newItem };

      setItems(tempItems);
    } else {
      setItems([newItem, ...items]);
    }

    setAddEditForm({ show: false, item: {} });
  };

  const deleteItem = (id: string) => {
    if (!deleting[id]) {
      setDeleting({ ...deleting, [id]: true });

      API.deleteContentDetails({ id })
        .then((res) => {
          if (res.type === "success") {
            const tempItems = items.filter((item) => item.id !== id);

            setItems(tempItems);
          }

          showToast(res.type, res.message);
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => setDeleting({ ...deleting, [id]: false }));
    }
  };

  const getIntialContent = () => {
    const params = {
      type,
      spaceId,
    };

    API.getContentDetails(params)
      .then((res) => {
        console.log("RES :", res);

        if (res.type === "success") {
          setItems(res.data);
        }
      })
      .catch((err) => {
        showToast("error", err.message);
      })
      .finally(() => setFetching(false));
  };

  useEffect(() => {
    getIntialContent();
  }, []);

  return (
    <div className="accordian-content-wrapper">
      <p className="accordian-content-description">
        {SECTION_DESCRIPTIONS[type]}
      </p>

      <div className="accordian-content-heading">
        <Button onClick={() => setAddEditForm({ show: true, item: {} })}>
          <FontAwesomeIcon icon={faPlus} color="#fff" /> Add New
        </Button>
      </div>

      {fetching && (
        <div className="no-result-wrapper">
          <p>
            <FontAwesomeIcon icon={faSpinner} spin />
          </p>
        </div>
      )}

      {!fetching && items && items.length == 0 && (
        <div className="no-result-wrapper">
          <p>No items added yet</p>
        </div>
      )}

      {items && items.length > 0 && (
        <div className="accordion-wrapper modal-accordion-content">
          <Accordion>
            {items.map((item, index) => (
              <Accordion.Item
                key={`item-key-${index}`}
                eventKey={`type-${index}`}
              >
                <div
                  className="schedule-form mt-0"
                  style={{ marginRight: 10, top: 25 }}
                >
                  <Button onClick={() => setAddEditForm({ show: true, item })}>
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>

                  <Button
                    style={{ marginLeft: 5 }}
                    onClick={() => deleteItem(item.id)}
                  >
                    {!deleting[item.id] && <FontAwesomeIcon icon={faTrash} />}

                    {deleting[item.id] && (
                      <FontAwesomeIcon icon={faSpinner} spin />
                    )}
                  </Button>
                </div>
                <Accordion.Header>{item.heading}</Accordion.Header>
                <Accordion.Body>
                  <div
                    className=""
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      )}

      {addEditForm.show && (
        <ContentItemForm
          type={type}
          show={addEditForm.show}
          onClose={() => setAddEditForm({ show: false, item: {} })}
          spaceId={spaceId}
          item={addEditForm.item}
          updateItem={updateItem}
        />
      )}
    </div>
  );
};

export default AccordianDataContent;
